import React, { useEffect, useState } from "react";
import { FaEye, FaVideo, FaArrowLeft, FaCalendarAlt, FaClock, FaVideoSlash } from "react-icons/fa";
import { getMyMeetingsApi } from "../../services/api";
import "./MeetingsPage.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

// ✅ Safe local datetime parser (Strips UTC 'Z' offset)
const parseLocalDateTime = (dateStr) => {
  if (!dateStr) return new Date();
  const cleanStr = String(dateStr).replace("Z", "").replace("T", " ");
  return new Date(cleanStr);
};

const MeetingsPage = () => {
  const [meetings, setMeetings] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [roleCode, setRoleCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadMeetings();
  }, []);

  const loadMeetings = async () => {
    try {
      const res = await getMyMeetingsApi();
      setMeetings(res.data.data || []);
      setRoleCode(String(res.data.roleCode || ""));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="bmaMeetingsWrapper">
      <div className="bmaMeetingsHeader">
        <h1>My Meetings</h1>
        <div className="bmaHeaderLine"></div>
      </div>

      {/* LIST VIEW */}
      {!selectedMeeting && (
        <div className="meetingListWrapper">
          <table className="meetingTable">
            <thead>
              <tr>
                <th>Project</th>
                <th>Role</th>
                <th>Application ID</th>
                <th>Meeting Type</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {meetings.length > 0 ? (
                meetings.map((meeting) => {
                  const startDate = parseLocalDateTime(meeting.meeting_start || meeting.slot_datetime);
                  const endDate = parseLocalDateTime(meeting.meeting_end || meeting.slot_datetime);
                  const statusVal = meeting.meeting_status || meeting.payment_status || "BOOKED";

                  return (
                    <tr key={meeting.id}>
                      <td>{meeting.role?.project?.project_name || "N/A"}</td>
                      <td>{meeting.role?.role_name || "N/A"}</td>
                      <td>{meeting.application_id}</td>
                      <td>{meeting.booking_type?.replaceAll("_", " ")}</td>
                      <td>
                        {startDate.toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric"
                        })}
                      </td>
                      <td>
                        {startDate.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}
                        {" - "}
                        {endDate.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}
                      </td>
                      <td>
                        <span className={`meetingStatus ${statusVal === "EXPIRED" ? "expiredStatus" : "bookedStatus"}`}>
                          {statusVal}
                        </span>
                      </td>
                      <td>
                        <div className="meetingActionBtns">
                          <button
                            className="viewBtn"
                            title="View Meeting"
                            onClick={() => {
                              if (roleCode === "300") {
                                const roleId = meeting.role?.id;
                                const slug = meeting.role?.urlSlug || meeting.role?.role_name?.toLowerCase()?.replace(/[–—]/g, "-")?.replace(/\s+/g, "-");
                                navigate(`/audition/${roleId}/${slug}`);
                                return;
                              }
                              if (roleCode === "200" || roleCode === "400") {
                                navigate(`/dashboard/manage-applications/${meeting.joget_audition_id}`);
                                return;
                              }
                            }}
                          >
                            <FaEye />
                          </button>
                          <button
                            className={`joinBtnIcon ${statusVal === "EXPIRED" ? "disabledBtn" : ""}`}
                            disabled={statusVal === "EXPIRED"}
                            title="Join Meeting"
                            onClick={async () => {
                              if (statusVal === "EXPIRED") {
                                Swal.fire({
                                  icon: "error",
                                  title: "Meeting Expired",
                                  text: "This meeting has already expired.",
                                });
                                return;
                              }

                              const result = await Swal.fire({
                                title: "Join Meeting?",
                                text: `Application ID: ${meeting.application_id}`,
                                icon: "",
                                showCancelButton: true,
                                confirmButtonText: "Yes, Join",
                                cancelButtonText: "Cancel",
                                confirmButtonColor: "#28a745",
                                cancelButtonColor: "#dc3545",
                              });

                              if (result.isConfirmed) {
                                window.open(
                                  `/meeting/audition-${meeting.application_id}`,
                                  "_blank"
                                );
                              }
                            }}
                          >
                            <FaVideo />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>No Meetings Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MeetingsPage;